import { render } from "./TranslationTabs.vue?vue&type=template&id=f2f5c62c"
import script from "./TranslationTabs.vue?vue&type=script&lang=js"
export * from "./TranslationTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__